import { waitForUsercentricsFirstLayer } from '~/composables/waitForUsercentricsFirstLayer'

// Loaded only when Google login is enabled, so Masuren does not download it.
export async function runGoogleOneTap (): Promise<void> {
  const config = useRuntimeConfig()
  const clientId = config.public.guestGoogleClientId as string | undefined
  if (!clientId) {
    return
  }

  const store = useGuestStore()
  const route = useRoute()
  const { ensureInitialized } = useGoogleIdentity()
  const { log } = useGuestActivityLog()

  if (useGuestLoginDeepLinkPending().value) {
    log('one_tap_skipped', { reason: 'deep_link' })
    return
  }

  if (route.path.startsWith('/guest')) {
    return
  }

  if (!store.user) {
    await store.getSession()
  }
  if (store.isLoggedIn) {
    return
  }

  const googlePromise = ensureInitialized()
  const firstLayer = await waitForUsercentricsFirstLayer()

  if (useGuestLoginDeepLinkPending().value) {
    log('one_tap_skipped', { reason: 'deep_link' })
    return
  }
  if (route.path.startsWith('/guest') || store.isLoggedIn) {
    return
  }

  const google = await googlePromise
  if (!google) {
    log('gis_missing', { source: 'one_tap' })
    return
  }
  log('one_tap_prompt', { after: firstLayer })
  google.accounts.id.prompt()
}
